import React from 'react';

const TableHeader = ({ children, className = '', ...props }) => {
  return (
    <thead className={`bg-gray-200 ${className}`} {...props}>
      {children}
    </thead>
  );
};

const TableHeaderCell = ({ 
  children, 
  align = 'left',
  // "= undefined" makes the prop optional for TypeScript callers.
  responsive = undefined,
  className = '',
  ...props 
}) => {
  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const responsiveClasses = {
    md: 'hidden md:table-cell',
    lg: 'hidden lg:table-cell',
    xl: 'hidden xl:table-cell'
  };

  const responsiveClass = responsive ? responsiveClasses[responsive] : '';
  const alignClass = alignClasses[align];

  return (
    <th 
      className={`px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider ${alignClass} ${responsiveClass} ${className}`}
      {...props}
    >
      {children}
    </th>
  );
};

export default TableHeader;
export { TableHeaderCell };
